import { render } from "./ImageZoomer.vue?vue&type=template&id=86209c2c&scoped=true"
import script from "./ImageZoomer.vue?vue&type=script&lang=js"
export * from "./ImageZoomer.vue?vue&type=script&lang=js"

import "./ImageZoomer.vue?vue&type=style&index=0&id=86209c2c&scoped=true&lang=css"

import exportComponent from "/builds/oleksandr.makhovskyi/admin-template/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-86209c2c"]])

export default __exports__